import { motion } from 'framer-motion';

interface IFilterButton {
  keyId: any;
  btnText: string;
  layoutId: string;
  color: string;
  width?: number;
  selectedValue: any;
  onClick: (value: any) => void;
}

const FilterButton = ({
  keyId,
  btnText,
  layoutId,
  color,
  width,
  selectedValue,
  onClick,
}: IFilterButton) => {
  // rendering calendar filter button component here
  return (
    <button
      onClick={() => onClick(keyId)}
      style={{ color, width: `${width}px` }}
      className='relative hover:opacity-70 hover:bg-base-light-gray active:scale-95 duration-300 italic'
    >
      {btnText}

      {keyId === selectedValue ? (
        <motion.div
          style={{ backgroundColor: color }}
          className='absolute left-0 right-0 -bottom-1 h-[2px]'
          layoutId={layoutId}
        ></motion.div>
      ) : null}
    </button>
  );
};

export default FilterButton;
